import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import Plyr from 'plyr';

@Component
export class VideoPlayer extends ThemeComponent  {
    @Prop({ default: false }) autoplay!: boolean;
    @Prop({ default: false }) muted!: boolean;

    @Ref() video!: HTMLVideoElement | HTMLIFrameElement | HTMLDivElement;

    private player!: Plyr;

    init() {

        // Init plyr
        this.player = new Plyr(this.video, {
            autoplay: this.autoplay,
            muted: this.muted
        });

        // Set muted properties
        this.player.muted = this.muted;

        // Autoplay
        if (this.autoplay) {
            void this.player.play();
        }
    }
}
